import gql from 'graphql-tag';
export const getPhoneNormalized = gql`
query normalizePhone {
  normalizePhones {
    phonesNormalized {
      phone
      phoneNormalized
    }
  }
}
`;

export const isModeMaintenance = gql`
query isModeMaintenance {
    isModeMaintenance
}
`;
export const getNotices = gql`
query getNotices {
  getNotices {
    id
      level
      title
      description
      infoUrl
  }
}
`;
